export default __webpack_public_path__ + "static/media/me3_RightCircle_Icon.91a0f124.png";